ul{list-style-type:none;margin-top:4px}
/*# sourceMappingURL=dac6-assign-transaction-cell-editor.component-T244RN6E.css.map */
